import Image from 'next/image';
import clsx from 'clsx';

import { resolveImageAltText } from '@/lib/utils';
import offsetBlockClass from '@/utils/offsetBlockClass';

export default function Notification({ block, position }) {
  if (!block?.notification?.reference?.[0]) {
    console.error('No notification content reference found!', position);
    return null;
  }

  const { font_bold, icon, message, show_offset_block_selector, text_color } =
    block.notification.reference[0];

  return (
    <div
      className={`flex ${offsetBlockClass(show_offset_block_selector, 'mb-8')}`}
    >
      {icon?.url && (
        <Image
          src={icon.url}
          alt={resolveImageAltText(icon)}
          width={24}
          height={24}
          sizes="24px"
          className="mr-2 inline-block min-w-[24px]"
        />
      )}
      <span
        className={clsx('body-s self-center tracking-[0.2px]', {
          [`text-[${text_color}]`]: text_color,
          'font-bold': font_bold
        })}
      >
        {message}
      </span>
    </div>
  );
}
